import { BRAND_CODE } from "@/config/common";
import { marketCode } from "@features/market/config/market-config";

/**
 *
 * @param attributes extra attributes to include.
 * @returns default set of attributes used in the app.
 */
export default function mapCustomAttributes(
  attributes: string[] = [],
  market: { code: string } | { countryCode: string },
) {
  const code = marketCode(market).toLowerCase();
  return [
    `number.rrp_${BRAND_CODE}_${code}`,
    "stockStatus",
    "variantFlags",
    "productFlags",
    "nextDeliveryDate",
    "number.stockOnHand",
    "number.delivery_time_days",
    "json.imagesKey",
    "json.productImageURLKey",
    "json.v2_productMainImageKey",
    "json.v2_productAdditionalImageKey",
    "json.v2_variantMainImageKey",
    "json.v2_variantAdditionalImageKey",
    "json.variantName",
    "leafCategoryCodes",
    "totalCategoryCodes",
    "bestStockStatus",
    "itemStatus",
    "defaultProductPartNo",
    "defaultProductImageKey",
    "defaultProductNG_PartNo",
    "defaultProductNG_ImageKey",
    "statuses",
    "productCode",
    "brandCode",
    "designerCode",
    `${BRAND_CODE}_${code}_fromPriceType`,
    `${BRAND_CODE}_${code}_fromPriceSame`,
    `number.vat_${BRAND_CODE}_${code}`,
    `number.${BRAND_CODE}_${code}_fromPrice`,
    `number.${BRAND_CODE}_${code}_fromPriceRRP`,
    `number.${BRAND_CODE}_${code}_fromPrice30Days`,
    `number.cmp30_${BRAND_CODE}_${code}`,
    ...attributes,
  ];
}
